import { graphql } from "@opensea/graphql"
import { getDropStatusFragment } from "@/components/collection/drops/utils"

export const CollectionLinkFragment = graphql(
  `
    fragment CollectionLink on CollectionIdentifier {
      slug
      ... on Collection {
        ...getDropStatus
      }
    }
  `,
  [getDropStatusFragment],
)
